import { render } from "./AppRoot.vue?vue&type=template&id=600e5a5d"
import script from "./AppRoot.vue?vue&type=script&lang=js"
export * from "./AppRoot.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__